export default __webpack_public_path__ + "static/media/paperCan.a0076992.svg";